module.exports = __webpack_public_path__ + "img/this_is_note_a_dress_this_is_a_tunic.da0bfd88.jpg";